import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Tabs, Tab } from "@mui/material";
import ServiceProviderPage from "./ServiceProviderPage";
import MaintenanceRequestsPage from "./MaintenantRequestPage";
import BreadcrumbsBar from "../../components/BreadcrumbsBar";
import ServiceManagementPage from "./ServiceManagementPage";

const ServiceProviderDashboard = () => {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box className="main-container mt-4">
      <BreadcrumbsBar/>
      <Tabs
        value={tabIndex}
        onChange={handleChange}
        indicatorColor="secondary"
        textColor="secondary"
        sx={{  mb: 1 }}
        centered
        
      >
        <Tab label={t("sp_dashboard.tab_service_provider")} />
        <Tab label={t("sp_dashboard.tab_maintenance_requests")} />
        <Tab label={t("sp_dashboard.tab_service_management")} />
        {/* <Tab label="Rating Dashboard" /> */}
      </Tabs>

      {tabIndex === 0 && <ServiceProviderPage />}
      {tabIndex === 1 && <MaintenanceRequestsPage/> }
      {tabIndex === 2 && <ServiceManagementPage/> }
      {/* {tabIndex === 2 && <Box></Box>}
      {tabIndex === 3 && <Box></Box>} */}
    </Box>
  );
};

export default ServiceProviderDashboard;
